import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  MainContainer: {
    background: "linear-gradient(179deg, #1F3052 27.67%, #49A995 149.13%)",
    height: "auto",
    marginTop: "-11.6rem",
    padding: "160px 80px",
    "@media (max-width: 1440px)": {
      padding: "160px 25px",
    },
  },
  StudyCasesText: {
    "&.MuiTypography-root": {
      marginTop: "3rem",
      fontSize: "64px",
      fontStyle: "italic",
      fontWeight: "400",
      fontFamily: "'Poppins', sans-serif",
      color: "#FFF",
      lineHeight: "120%",
      textAlign: "center",
      marginBottom: "2rem",
      "@media (max-width: 500px)": {
        fontSize: 50,
      },
    },
  },
  StudyCasesCardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    "@media (max-width: 410px)": {
      paddingLeft: "0px",
    },
  },
  StudyCasesCardContainerOne: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "1.8rem",
    justifyContent: "flex-start",
  },
  StudyCasesSpan: {
    color: "#49A995",
    fontSize: "75px",
    fontStyle: "italic",
    fontWeight: "600",
    fontFamily: "'Poppins', sans-serif",
    lineHeight: "93%",
  },

  APPROCHESpan: {
    color: "#49A995",
    fontSize: "75px",
    fontStyle: "italic",
    fontWeight: "600",
    fontFamily: "'Poppins', sans-serif",
    lineHeight: "93%",
    "@media (max-width: 1100px)": {
      fontSize: "64px",
    },
    "@media (max-width: 500px)": {
      fontSize: 50,
    },
  },
  PROCESSUSSpan: {
    display: "block",
    color: "#49A995",
    fontSize: "75px",
    fontStyle: "normal",
    fontWeight: "600",
    fontFamily: "'Poppins', sans-serif",
    lineHeight: "93%",
    "@media (max-width: 1100px)": {
      fontSize: "64px",
    },
    "@media (max-width: 500px)": {
      fontSize: 50,
    },
  },

  StudyCasesTextParagraphy: {
    "&.MuiTypography-root": {
      color: "#FFFF",
      fontSize: "24px",
      fontWeight: "500",
      fontFamily: "Poppins",
      lineSpacing: "-0.96px",
      lineHeight: "normal",
      textAlign: "center",
      fontStyle: "normal",
      letterSpacing: "-0.96px",
      "@media (max-width: 1032px)": {
        marginTop: "5px",
      },
      "@media (max-width: 440px)": {
        marginTop: "15px",
      },
    },
  },

  EXPOMINParagraphy: {
    "&.MuiTypography-root": {
      color: "#FFFF",
      fontSize: "40px",
      fontWeight: "300",
      fontFamily: "Poppins",
      lineSpacing: "-0.96px",
      lineHeight: "normal",
      textAlign: "center",
      fontStyle: "bold",
      letterSpacing: "-0.96px",
      "@media (max-width: 1032px)": {
        marginTop: "5px",
      },
      "@media (max-width: 440px)": {
        marginTop: "15px",
      },
    },
  },
  ExpominSpan: {
    display: "block",
  },

  SolutionSpan: {
    color: "#49A995",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Poppins",
    lineSpacing: "-0.96px",
    lineHeight: "normal",
    textAlign: "center",
  },

  innovantesSpan: {
    display: "block",
    color: "#49A995",
    fontSize: "37px",
    fontWeight: "600",
    fontFamily: "Poppins",
    lineSpacing: "-0.96px",
    lineHeight: "normal",
    textAlign: "center",
  },
  StandText: {
    display: "block",
  },

  FindUsText: {
    "&.MuiTypography-root": {
      color: "#49A995",
      fontSize: "22px",
      fontWeight: "500",
      fontFamily: "Poppins",
      lineSpacing: "-0.96px",
      lineHeight: "21px",
      textAlign: "center",
      fontStyle: "normal",
      letterSpacing: "-0.96px",
      marginTop: "1rem",
      "@media (max-width: 1032px)": {
        marginTop: "5px",
      },
      "@media (max-width: 440px)": {
        marginTop: "15px",
      },
    },
  },

  DateParagraphy: {
    "&.MuiTypography-root": {
      color: "#49A995",
      fontSize: "22px",
      fontWeight: "500",
      fontFamily: "Poppins",
      lineSpacing: "-0.96px",
      lineHeight: "normal",
      textAlign: "center",
      fontStyle: "normal",
      letterSpacing: "-0.96px",
      marginTop: "1.5rem",
      "@media (max-width: 1032px)": {
        marginTop: "5px",
      },
      "@media (max-width: 440px)": {
        marginTop: "15px",
      },
    },
  },

  FindSpan: {
    color: "#FFF",
    fontSize: "22px",
    fontWeight: "300",
    fontFamily: "Poppins",
    lineSpacing: "-0.96px",
    lineHeight: "normal",
    textAlign: "center",
    fontStyle: "normal",
    letterSpacing: "-0.96px",
    marginTop: "2rem",
  },

  TiltContainer: {
    perspective: "600px",
    width: "409.196px",
    height: "275.647px",
    marginTop: "2.5rem",
    marginBottom: "2.5rem",
    "@media (max-width: 1440px)": {
      width: "389.196px",
      height: "256.647px",
    },
    "@media (max-width: 405px)": {
      width: "370.196px",
      height: "250.647px",
    },
    "@media (max-width: 382px)": {
      marginLeft: "8px",
    },
  },
  TiltedImage: {
    width: "100%",
    height: "100%",
    transform: "rotateY(18deg) rotateX(6deg)",
    borderRadius: "22% 28% 28% 22%",
    objectFit: "cover",

    "@media (max-width: 405px)": {
      width: "103%",
      marginLeft: "0px",
    },

    "@media (max-width: 430px)": {
      marginLeft: "5px",
    },

    "@media (max-width: 395px)": {
      width: "100%",
      height: "98%",
      paddingLeft: "7px",
    },

    "@media (max-width: 382px)": {
      width: "97%",
      height: "95%",
    },
  },
  CenterTiltedImage: {
    width: "100%",
    height: "100%",
    transform: "rotateY(-10deg) rotateX(6deg)",
    borderRadius: "24% 22% 22% 24%",
  },
  Border: {
    width: "404.586px",
    height: "271.022px",
    content: '""',
    position: "absolute",
    top: "-14px",
    left: "10px",
    right: "0",
    bottom: "0",
    border: "3px solid #35A999",
    borderRadius: "23% 29% 24% 20%",
    transform: "rotateY(16deg) rotateX(6deg)",
    "@media (max-width: 1440px)": {
      width: "381.586px",
      height: "256.022px",
    },

    "@media (max-width: 395px)": {
      width: "370.586px",
      height: "248.022px",
    },

    "@media (max-width: 382px)": {
      width: "360.586px",
      height: "240.022px",
      marginRight: "13px",
    },
  },

  CenterBorder: {
    width: "411.586px",
    height: "271.022px",
    content: '""',
    position: "absolute",
    top: "-13px",
    left: "-18px",
    right: "0",
    bottom: "0",
    border: "3px solid #35A999",
    transform: "rotateY(-10deg) rotateX(6deg)",
    borderRadius: "24% 20% 22% 24%",
    "@media (max-width: 1440px)": {
      top: "-11px",
      left: "-15px",
      width: "389.586px",
      height: "257.022px",
    },
  },
  AboutCard: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontFamily: "'Poppins', sans-serif",
      fontSize: 24,
      fontWeight: 700,
      width: "345px",
      textAlign: "center",
    },
  },
  StudyCaseCardWrapper: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "52px",
    flexWrap: "wrap",
  },
  ExploreMoreButtonWraapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ExploreMoreButton: {
    textDecoration: "none",
    "&.MuiButtonBase-root": {
      textTransform: "capitalize",
      borderColor: "#FFF",
      borderRadius: 6,
      fontFamily: "'Inter', sans-serif",
      fontSize: 14,
      fontWeight: 600,
      color: "#FFF",
      height: 51,
      width: 144,
      marginTop: 52,
      "&:hover": {
        border: "none",
        backgroundColor: "#025b62ff",
      },
    },
  },
  SavoirBtn: {
    "&.MuiButtonBase-root": {
      textTransform: "capitalize",
      color: "#49A995",
      fontFamily: "Poppins",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "normal",
      marginTop: "1rem",
      borderRadius: 6,
      zIndex: "1",
      "&:hover": {
        color: "white",
        backgroundColor: "#49A995",
      },
    },
  },
  MineSolutionBox: {
    display: "flex",
    marginTop: "6rem",
    justifyContent: "center",
    alignItems: "center",
    gap: "4rem",
    "@media (max-width: 1250px)": {
      flexWrap: "wrap",
    },
  },
  MineTextBox: {
    marginTop: "-6rem",
    // display: "flex",
    // justifyContent: "center",
    // flexDirection: "column",
    // alignItems: "center",
  },
  ExpominBox: {
    display: "flex",
    justifyContent: "center",
  },
  solutionText: {
    // marginTop: "-3rem",
    // width: 400,
  },
  MineImage: {
    width: "100%", // Makes it responsive to parent container
    maxWidth: "700px", // Keeps it from growing too large on big screens
    height: "auto", // Maintains aspect ratio

    "@media (max-width: 1250px)": {
      maxWidth: "100%", // allows full responsiveness on small screens
    },
  },
  ExpominImage: {
    width: "100%", // Makes the image take full width of its container
    height: "auto", // Maintains aspect ratio
    maxWidth: "700px", // Optional: limit it on large screens
    maxHeight: "250px", // Limit height on large screens

    "@media (max-width: 768px)": {
      height: 200,
      maxWidth: "100%", // Allows the image to scale down
      maxHeight: "none", // Remove maxHeight constraint to let it shrink
    },
  },
}));
